import {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import kapi from "../api/kratos";
import text_utils from "../utils/TextUtils";
import eye from "../assets/eye.png";
import check from "../assets/green-tick-circle.svg";
import cross from "../assets/red_cross.png";


const Register = () => {

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [flowResponse, setFlowResponse] = useState();

    const [showPasswordGuide, setShowPasswordGuide] = useState(false);

    const navigate = useNavigate();


    const InitRegistration = () => {
        // clear any existing user in storage
        localStorage.removeItem("user");

        let response = kapi.init_registration();
        response.then(response => {
            setFlowResponse(response.data);
        }, function() {
            navigate("/logout");
        })
    }

    const PageLoad = () => {
        const params = new URLSearchParams(window.location.search);
        const flowId = params.get('flow');

        if (!flowId) {
            InitRegistration();
        }
        else {
            let response = kapi.get_registration(flowId);
            response.then(response => {
                setFlowResponse(response.data);
                setFirstName(response.data.ui.nodes.find(n => n.attributes.name === 'traits.name.first').attributes.value)
                setLastName(response.data.ui.nodes.find(n => n.attributes.name === 'traits.name.last').attributes.value)
                setEmail(response.data.ui.nodes.find(n => n.attributes.name === 'traits.email').attributes.value)
            }).catch(err => {
                console.log("Unable to retrieve registration: " + err);
            });
        }
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const toggleShowConfirmedPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const checkAllPasswordConditions = () => {
        if (!password) return false
        return (text_utils.containsSpecial(password) &&
            text_utils.containsDigit(password) &&
            text_utils.containsCapital(password) &&
            password.length >= 8 &&
            password === confirmPassword)
    }

    useEffect(() => {
        PageLoad()
    }, []);

return (
        <>
            <div className="register-page-container">
                <div className="sign-up-container">
                    <div className="register-welcome-container col">
                        <div className="register-welcome-title">
                            Create account
                        </div>
                        <div className="register-welcome-subtitle">
                            Sign up to get started
                        </div>
                        <div className="register-login-container">
                            Already have an account?
                            <Link to="/login">Sign in here</Link>
                        </div>
                    </div>
                    <div className="register-form-container col">
                        <form name="register-form" action={flowResponse && flowResponse.ui.action} method="POST">
                            <div>
                                {flowResponse && flowResponse?.ui?.messages?.map((msg, idx) => {
                                    return (
                                        <div className="messages" key={idx}>{msg.text}</div>
                                    )
                                })}
                            </div>
                            <input name="csrf_token" type="hidden"
                                   value={flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'csrf_token')?.attributes.value}/>
                            <div className="field-input">
                                <div className="label">Email</div>
                                <div className="field-input-entry">
                                    <input className="login-input" name="traits.email" type="email" value={email}
                                           onChange={(ev) => setEmail(ev.target.value)}
                                           required/>
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'traits.email')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">First name</div>
                                    <input name="traits.name.first"
                                           type="text" value={firstName}
                                           onChange={(ev) => setFirstName(ev.target.value)}
                                           required/>
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'traits.name.first')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Last name</div>
                                    <input name="traits.name.last"
                                           type="text" value={lastName}
                                           onChange={(ev) => setLastName(ev.target.value)}
                                           required/>
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'traits.name.last')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Password</div>
                                    <input name="password"
                                           type={showPassword ? "text" : "password"} value={password}
                                           onChange={(ev) => {
                                               setPassword(ev.target.value)
                                               setShowPasswordGuide(true)
                                           }}
                                           onFocus={() => {
                                               setShowPasswordGuide(true)
                                           }}
                                           required/>
                                    <img src={eye} onClick={toggleShowPassword} alt="eye logo"
                                         className="eye link"/>
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'password')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Confirm password</div>
                                    <input name="confirm-password"
                                           type={showConfirmPassword ? "text" : "password"} value={confirmPassword}
                                           onChange={(ev) => setConfirmPassword(ev.target.value)}
                                           required/>
                                    <img src={eye} onClick={toggleShowConfirmedPassword} alt="eye logo"
                                         className="eye link"/>
                                </div>
                            </div>
                            {showPasswordGuide && showPasswordGuide ?
                                <div className="password-guide-container">
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={password && password.length >= 8 ? check : cross} alt='password-check'/>
                                        </div>
                                        Minimum number of characters: 8
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={text_utils.containsCapital(password) ? check : cross} alt='password-check'/>
                                        </div>
                                        Include at least 1 capital character
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={text_utils.containsDigit(password) ? check : cross} alt='password-check'/>
                                        </div>
                                        Include at least 1 numeric character
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={text_utils.containsSpecial(password) ? check : cross} alt='password-check'/>
                                        </div>
                                        Include at least 1 special character
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={password === confirmPassword ? check : cross} alt='password-check'/>
                                        </div>
                                        Passwords must match
                                    </div>
                                </div>
                                : null
                            }
                            <div className="field-input">
                                {!email || !firstName || !lastName || !checkAllPasswordConditions() ?
                                    <button className="register-button invalid link" name="method" type="button"
                                            value="password" onClick={() => console.log("Register conditions not met")}>
                                        Register
                                    </button>
                                    :
                                    <button className="register-button link" name="method" type="submit"
                                            value="password"
                                            disabled={!email || !firstName || !lastName || !checkAllPasswordConditions()}>
                                        Register
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
)
}

export default Register